module.exports = __webpack_public_path__ + "img/CastleofCain.0c8c9b50.png";